import actions from "./actions";

const setActiveCustomFilter = actions.setActiveCustomFilter;
const setCustomFilters = actions.setCustomFilters;

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  setActiveCustomFilter,
  setCustomFilters
};
